import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';

interface HStackProps {
  $spacing?: number;
  $valign?: 'top' | 'center' | 'bottom' | 'baseline';
}

export const HStack = styled.div.withConfig({ componentId: 'sc-cuiqel-0' })<HStackProps>`
    display: flex;

    ${({ $spacing }) =>
      $spacing &&
      css`
            gap: ${size($spacing)};
        `}

    ${({ $valign }) =>
      $valign === 'top'
        ? css`
                  align-items: start;
              `
        : $valign === 'center'
          ? css`
                  align-items: center;
              `
          : $valign === 'bottom'
            ? css`
                  align-items: end;
              `
            : $valign === 'baseline'
              ? css`
                  align-items: baseline;
              `
              : undefined}
`;
